import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";
import { Divider, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Button } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import axiosInstance from "../../Config/axios";
import { API_URLS } from "../../Config/API_URLS";
import Cart from "../../Shared/MultiVendorHeader/Cart";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function SubscriptionVerticalTabs() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [bid, setBId] = useState("");

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const GetSubscriptionList = () => {
    axiosInstance
      .post(API_URLS.subscriptionList)
      .then((response) => {
        setData(response?.data?.brand_data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const GetSubscriptionList1 = () => {
    const reqBody = new FormData();
    reqBody.append("subscription_plan_id", bid);
    axiosInstance
      .post(API_URLS.showSubscription, reqBody)
      .then((response) => {
        setData1(response?.data?.subscription_details);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    GetSubscriptionList();
    GetSubscriptionList1();
    bid && GetSubscriptionList1();
  }, [bid]);
  console.log(bid, "ugtyufyuf");
  return (
    <>
      <div className="px-3 ">
        <div
          className="flex justify-between  lg-pt-0 pt-10 py-5"
          onClick={() => navigate("/")}
        >
          <p className="font-bold lg:text-2xl text-center font-sans">
            <ArrowBackIcon />
            &nbsp;&nbsp;&nbsp; Subscription
          </p>
          <HelpOutlineRoundedIcon />
        </div>

        <div className="py-5" onClick={() => navigate("/save")}>
          <img
            src="https://img.freepik.com/premium-vector/newsletter-subcription-online-mobile-app-vector-gradient-illustration-isometric-smartphone-with-new-monthly-letter-flying-out-screen-staying-up-date-get-news-recent-updates_509478-115.jpg?w=1380"
            alt=""
            className="w-full h-[400px]"
          />
        </div>
        <Divider />
        {/* <Box
          sx={{
            flexGrow: 1,
            bgcolor: "background.paper",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Tabs
            orientation="horizontal"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            sx={{ borderColor: "divider" }}
          >
            <Tab label="My Subscription" {...a11yProps(0)} />
          
          </Tabs>
          <Divider />

          <TabPanel value={value} index={0}>
            <div className="flex flex-col justify-center items-center px-10">
              <div className="flex lg:flex-row flex-col lg:gap-5 py-3 justify-center px-10">
                {data?.map((item) => {
                  return (
                    <Button
                      variant="contained"
                      className="!p-2 hm1 lg:!text-2xl !mt-10"
                      onClick={() => {
                        item.id == 5 && setBId(item.id) ;
                        item.id === 6 && setBId(item.id) ;
                        item.id === 7 && setBId(item.id) ;
                      }}
                    >
                      {item?.subscription_name}
                    </Button>
                  );
                })}
              </div>
              <div className="flex items-center  overflow-x-auto hide-scroll w-96 justify-between py-5 gap-3 px-4 ">
                {data1?.map((item) => {
                  return (
                    <div className="">
                      <Card sx={{ maxWidth: 300 }} className="!rounded-xl">
                        <CardMedia
                          sx={{ height: 80 }}
                          image={item?.product_variant?.variant_image}
                          title="green iguana"
                          className="!w-[170px] !mt-3 !h-24 !bg-cover"
                        />
                        <CardContent className="!px-2 !py-2">
                          <Typography
                            gutterBottom
                            variant=""
                            className="!text-start"
                            component="div"
                          >
                            <span className="text-gray-800 font_product">
                              {item?.product_variant?.product_variant_name}
                            </span>
                          </Typography>
                          <Typography
                            variant="body2"
                            className="!text-start !text-[10px]"
                            color="text.secondary"
                          >
                            <div className="flex  my-3">
                              <p className="font-bold text-black text-xs">SubScription :</p>
                              <p className="font-bold text-blue-600  pl-3">{item.subscription_choice.subscription_name}</p>
                            </div>
                            <div className="!text-[18px] mb-0 !text-gray-800">
                              {item?.product_variant?.price}
                              <span className="!text-gray-400">
                                ₹{item?.product_variant?.discount_percent}
                              </span>
                            </div>
                          </Typography>
                        </CardContent>
                        <CardActions className="!py-2">
                          <Button
                            size="small"
                            variant="outlined"
                            className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                            onClick={() => navigate(`/product/${item?.product_variant?.product}`)}
                          >
                           Subscribed 
                          </Button>
                          <Button>
                            Buy Now
                          </Button>
                          
                        </CardActions>
                      </Card>
                    </div>
                  );
                })}
              </div>
            </div>
          </TabPanel>
          
        </Box> */}
        <div className="flex flex-col justify-center items-center px-10">
          <div className="flex lg:flex-row flex-col lg:gap-5 py-3 justify-center px-10">
            {data?.map((item) => {
              return (
                <Button
                  variant="contained"
                  className="!p-2 hm1 lg:!text-2xl !mt-10"
                  onClick={() => {
                    item.id == 5 && setBId(item.id);
                    item.id === 6 && setBId(item.id);
                    item.id === 7 && setBId(item.id);
                  }}
                >
                  {item?.subscription_name}
                </Button>
              );
            })}
          </div>
          <div className="grid grid-cols-4 items-center  overflow-x-auto hide-scroll justify-between py-5 gap-3 px-4 ">
            {data1?.map((item) => {
              return (
                <div className="">
                  <Card sx={{ maxWidth: 300 }} className="!rounded-xl">
                    <CardMedia
                      sx={{ height: 80 }}
                      image={item?.product_variant?.variant_image}
                      title="green iguana"
                      className="!w-[170px] !mt-3 !h-24 !bg-cover"
                    />
                    <CardContent className="!px-2 !py-2">
                      <Typography
                        gutterBottom
                        variant=""
                        className="!text-start"
                        component="div"
                      >
                        <span className="text-gray-800 font_product">
                          {item?.product_variant?.product_variant_name}
                        </span>
                      </Typography>
                      <Typography
                        variant="body2"
                        className="!text-start !text-[10px]"
                        color="text.secondary"
                      >
                        <div className="flex  my-3">
                          <p className="font-bold text-black text-xs">
                            SubScription :
                          </p>
                          <p className="font-bold text-blue-600  pl-3">
                            {item.subscription_choice.subscription_name}
                          </p>
                        </div>
                        <div className="!text-[18px] mb-0 !text-gray-800">
                          {item?.product_variant?.price}
                          <span className="!text-gray-400">
                            ₹{item?.product_variant?.discount_percent}
                          </span>
                        </div>
                      </Typography>
                    </CardContent>
                    <CardActions className="!py-2">
                      <Button
                        size="small"
                        variant="outlined"
                        className="!font-bold w-[100%] !rounded-lg !border-blue-600 !border-[1.5px]"
                      >
                        Go Cart & Purchased
                      </Button>
                    </CardActions>
                  </Card>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
